import DriversComponents from '../../permissions/constants/driversComponents';
import UserPermissions from '../constants/userPermissions';
import { PermissionRules } from '../usePermissions';

type driversComponentRegistry = {
  [name in DriversComponents]: PermissionRules;
};

const DriversComponentRegistry: driversComponentRegistry = {
  DriverListing: {
    [UserPermissions.CREATE_DRIVERS]: true,
    [UserPermissions.EDIT_DRIVERS]: true,
    [UserPermissions.DELETE_DRIVERS]: true,
  },
  PendingInviteBanner: {
    [UserPermissions.INVITE_DRIVERS]: true,
  },
  DeleteDriver: {
    [UserPermissions.DELETE_DRIVERS]: true,
  },
};

export default DriversComponentRegistry;
